import * as urlParsers from "./urlParsers";
import wrappedAxios, { AxiosResponse } from "../axiosWrapper";
import { ModuleMetadataAPI, ModuleFormData, Modules } from "./types";
import { SOR, TemplateId } from "../../globalTypes";
import { Table } from "../table/types";

export const fetchAllModulesMetadata = () =>
  wrappedAxios<ModuleMetadataAPI[]>({
    url: urlParsers.fetchAllModulesMetadata(),
    method: "get",
  });

export const fetchModuleMetadata = (templateId: TemplateId) =>
  wrappedAxios<ModuleMetadataAPI>({
    url: urlParsers.fetchModuleMetadata(templateId),
    method: "get",
  });

export const fetchModules = (visibleOnly: boolean) =>
  wrappedAxios<Modules>({
    url: urlParsers.getModules(visibleOnly),
    method: "GET",
  });

export const requestDeleteModule = (rowKey: string | number) =>
  wrappedAxios<string>({
    url: urlParsers.deleteModule(rowKey),
    method: "delete",
  });

// Please use administration/fetchAdminTableData
export const fetchAdministrationModuleTable = (
  pageNum: number,
  maxPageRowCount: number,
  searchOrder: SOR,
  hiddenColumns: string[],
  fulltextKeyword: string | undefined
) =>
  wrappedAxios<Table>({
    url: urlParsers.getAdministrationModuleTable(
      pageNum,
      maxPageRowCount,
      JSON.stringify(searchOrder),
      hiddenColumns,
      fulltextKeyword
    ),
    method: "GET",
  });

export const insertModuleTableRow = (templateData: ModuleFormData) =>
  wrappedAxios<string>({
    url: urlParsers.postModule(),
    method: "POST",
    data: {
      ...templateData,
    },
  });

export const updateModuleTableRow = (
  templateData: ModuleFormData,
  rowId: string | number
) =>
  wrappedAxios<string>({
    url: urlParsers.updateModule(rowId),
    method: "PATCH",
    data: {
      ...templateData,
    },
  });

export const updateModulesOrderRequest = (
  modulesOrder: Record<number, number>
): AxiosResponse<void> =>
  wrappedAxios<void>({
    url: urlParsers.updateModulesOrder(),
    method: "PUT",
    data: {
      ...modulesOrder,
    },
  });

export const updateTemplatesOrderByModuleIdRequest = (
  moduleId: number,
  templatesOrder: Record<number, number>
): AxiosResponse<void> =>
  wrappedAxios<void>({
    url: urlParsers.updateTemplatesOrderForModule(moduleId),
    method: "PUT",
    data: {
      ...templatesOrder,
    },
  });
